export const configMarker = {
  title: "Servicio: ",
  field: "folio",
  rows: [
    {
      text: "Cuenta: ",
      field: "account",
    },
    {
      text: "Cantidad: ",
      field: "quantity",
    },
    {
      text: "Fecha programada: ",
      field: "programDate",
    },
  ],
};
